{
  "parshall-slices-results": {
    "title": "Результати додаткової діагностики",
    "slice-card": { "button": "Переглянути" },
    "slice-dynamics-card": {
      "last-chekup": "з останнього чекапу {{lastCheckupDate}}"
    }
  },
  "full-slice-results": {
    "linear-chart": {
      "title": "Динаміка {{name}}"
    },
    "scales-title": "Шкали-маркери стану"
  },
  "last-chekup": "з останнього чекапу"
}
